import React from 'react';
import './MesuarableTdItem.css';
import '../../../../../../assets/scss/user.scss';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

export const QueueTooltip = ({ loading, queues }) => {
  if (loading) return <div>Loading...</div>;
  if (!queues.length) return <div>No data</div>;
  const getStatusClass = status => {
    switch (status) {
      case 'PENDING':
        return 'status-pending';
      case 'DONE':
        return 'status-success';
      case 'FAILED':
        return 'status-failed';
      default:
        return '';
    }
  };
  const formatTime = date => {
    const d = dayjs(date);
    const now = dayjs();

    return d.year() === now.year()
      ? d.format('DD/MM HH:mm')
      : d.format('DD/MM/YYYY HH:mm');
  };

  return (
    <table style={{ width: '100%', fontSize: '12px' }}>
      <thead>
        <tr>
          <th style={{ borderBottom: '1px solid #ccc', padding: '4px 8px' }}>
            Status
          </th>
          <th style={{ borderBottom: '1px solid #ccc', padding: '4px 8px' }}>
            Created By
          </th>
          <th style={{ borderBottom: '1px solid #ccc', padding: '4px 8px' }}>
            Time
          </th>
          <th style={{ borderBottom: '1px solid #ccc', padding: '4px 8px' }}>
            Value
          </th>
        </tr>
      </thead>
      <tbody>
        {queues.map(q => (
          <tr key={q.id}>
            <td style={{ padding: '4px 8px' }}>
              <span className={getStatusClass(q.status)}>{q.status}</span>
            </td>
            <td style={{ padding: '4px 8px' }}>{q.createdBy}</td>
            <td style={{ padding: '4px 8px' }}>{formatTime(q.createdAt)}</td>
            <td style={{ padding: '4px 8px' }}>{q.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
QueueTooltip.propTypes = {
  loading: PropTypes.bool,
  queues: PropTypes.array,
};

